import * as React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button, Space, Table, Tag } from 'antd';
import moment from 'moment';
import {
  antTableWrapperSx,
  defaultPaginatedTableProps,
} from './AntTableStyles';
import {
  BAZAAR_STATUS_COLORS, bazaarStatusLabel, bazaarModeLabel,
} from './bazaarUtils';

export const BazaarsTable = ({
  bazaars,
  pagination,
  page,
  setPage,
  isLoading,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const columns = [
    { title: 'Brand', dataIndex: 'brand' },
    { title: 'Bazaar', dataIndex: 'name' },
    { title: 'Location', dataIndex: 'location' },
    { title: 'Dates', dataIndex: 'dates' },
    { title: 'Mode', dataIndex: 'mode' },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (_, { statusKey, statusLabel }) => (
        <Tag color={BAZAAR_STATUS_COLORS[statusKey]}>{statusLabel}</Tag>
      ),
    },
    {
      title: 'Actions',
      render: (_, { _id }) => (
        <Space>
          <Button onClick={() => navigate(`/ims/admin/bazaars/${_id}`)}>
            Manage
          </Button>
        </Space>
      ),
    },
  ];

  const data = bazaars?.map((row) => {
    const statusKey = row.displayStatus || row.status;
    return {
      _id: row._id,
      brand: row.vendor?.brandName || '—',
      name: row.name,
      location: row.location,
      dates: `${moment(row.startDate).format('DD/MM/YY')} – ${moment(row.endDate).format('DD/MM/YY')}`,
      mode: bazaarModeLabel(row.fulfillmentMode),
      statusKey,
      statusLabel: bazaarStatusLabel(statusKey),
    };
  });

  return (
    <Box sx={antTableWrapperSx(isMobile)}>
      <Table
        columns={columns}
        dataSource={data}
        loading={isLoading}
        rowKey="_id"
        pagination={defaultPaginatedTableProps({
          current: page,
          pageSize: parseInt(pagination?.limit, 10) || 100,
          total: pagination?.totalDocs,
          onChange: (nextPage) => setPage(nextPage),
          itemLabel: 'bazaars',
        })}
        scroll={{ x: isMobile ? 300 : 1100 }}
      />
    </Box>
  );
};

export default BazaarsTable;
